module.exports = __webpack_public_path__ + "static/media/Intro_Pharmacy_Text.91dbfd3d.png";